import React from "react";
//Material imports
import CircularProgress from "@mui/material/CircularProgress";
//Limitless imports
import AnimateList from "../animation/animate-list/AnimateList";
import KnowledgeArticleTile from "./KnowledgeArticleTile";
import { useKnowledgeLibraryContext } from "../../hooks/knowledge/KnowledgeLibraryContext";
import KnowledgeSearchInput from "../../components-modern/knowledge-search-input/KnowledgeSearchInput";
import Grid from "@limitless/modern/layout/Grid";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import Typography from "@limitless/modern/data-display/typography/Typography";
import NoArticle from "./NoArticle";
const KnowledgeSearch = () => {
  const {
    selectedArticle,
    libraryResults,
    selectCategory,
    SUBCATEGORY_CHAR
  } = useKnowledgeLibraryContext();
  const {
    hasSearched,
    loading,
    faqs,
    categories,
    searchResults,
    selectedCategory
  } = libraryResults;
  const {
    selectedArticleIndex,
    focusArticleAttention
  } = selectedArticle;
  const categoryList = React.useMemo(() => {
    if (categories.length === 0) {
      return [];
    }
    const categoryList = [];
    categories.map(category => {
      categoryList.push({
        label: category.category,
        value: category.category
      });
      if (category.subcategory) {
        category.subcategory.map(subcategory => {
          const label = SUBCATEGORY_CHAR + subcategory;
          const value = category.category + name;
          categoryList.push({
            label,
            value,
            category
          });
        });
      }
    });
    return categoryList;
  }, [categories]);
  const renderArticleCard = (article, index, {
    selectedArticleIndex
  }) => {
    return /*#__PURE__*/React.createElement(KnowledgeArticleTile, {
      key: index,
      article: article,
      index: index,
      expanded: index === selectedArticleIndex
    });
  };
  if (focusArticleAttention) {
    if (loading || !selectedArticle.question) {
      return /*#__PURE__*/React.createElement(Grid, {
        mt: 4,
        mr: 2,
        ml: 2,
        mb: 2
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 16,
        color: "secondary"
      }));
    }
    return /*#__PURE__*/React.createElement(Grid, {
      mt: 4,
      mr: 2,
      ml: 2,
      mb: 2
    }, renderArticleCard(selectedArticle, 0, {
      selectedArticleIndex: 0
    }));
  }
  return /*#__PURE__*/React.createElement(Grid, {
    mt: 3,
    mr: 2,
    ml: 0,
    mb: 2,
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(KnowledgeSearchInput, {
    label: "Search for articles"
  }), /*#__PURE__*/React.createElement(Grid, {
    mt: 3.1,
    item: true
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    label: "Category",
    id: "knowledgeCategoryDropdown",
    value: selectedCategory,
    options: categoryList,
    onChange: (e, selectedValue) => selectCategory(selectedValue),
    placeholder: categoryList.length ? "Filter FAQs by category" : "No categories available",
    disableClearable: false
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    mt: 3,
    direction: "column"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, !hasSearched ? "FAQ" : "Search Results"), !hasSearched && !loading && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: {
      width: "inherit"
    }
  }, /*#__PURE__*/React.createElement(AnimateList, {
    items: faqs,
    renderListItem: renderArticleCard,
    selectedItem: {
      title: selectedArticle.question,
      selectedArticleIndex,
      loading: selectedArticle.loading
    }
  })), hasSearched && !loading && searchResults.map((article, index) => {
    return renderArticleCard(article, index, {
      selectedArticleIndex
    });
  }), hasSearched && !loading && searchResults.length === 0 && /*#__PURE__*/React.createElement(NoArticle, null)));
};
export default KnowledgeSearch;